import { request } from './request'

export type VotePostArgs = {
  postId: string
}

export type VotePostResult = {
  hasVoted: boolean
  voteCount: number
}

export const votePost = async ({
  postId,
}: VotePostArgs): Promise<VotePostResult> =>
  request<VotePostResult>({
    path: `/api/posts/${postId}/vote`,
    method: 'POST',
  })
